// extracted by mini-css-extract-plugin
export default {"toggle_msg":"toggle_msg_blU1_TkW","grey-icon":"grey-icon_tv_GbvdH"};